const translations = {
	page_title: "Souscriptions",
	title: "Espace souscription",
	button: "Créer une souscription manuelle",
	sub_pages: {
		draft: {
			page_title: "Brouillons",
			date: "Date de création",
		},
		table: {
			find_subscription: "Chercher une souscription",
			full_name: "Souscripteur",
			cabinet_name: "Nom du cabinet (CGP)",
			cgp_email: "Email du CGP",
			cgp_phone: "Téléphone du CGP",
			payment_method: "Méthode de réglement",
			product_name: "Nom du produit",
			subscription_product_type: "Type de souscription",
			amount: "Montant",
			number_of_shares: "Nombre de parts",
			status: "Statut",
			type: "Type",
			product_anomaly: "Ce produit a été signalé par le partenaire",
			other_product_anomaly: "Un autre produit de la même souscription a été signalé",
			rto_anomaly: "Le document RTO a été signalé",
			rto_and_product_anomaly: "Le document RTO et un autre produit de la même souscription ont été signalés",
		},
		to_process: {
			page_title: "À traiter",
			date: "Date de réception",
		},
		waiting_signature: {
			page_title: "En attente de signature",
			date: "Date d'envoi pour signature au client",
		},
		waiting_contrepartie: {
			page_title: "En attente de contrepartie",
			date: "Date d'envoi pour contrepartie au client",
		},
		waiting_transfer_sg: {
			page_title: "À transmettre SDG",
			date: "Date d'envoi à la société de gestion",
			button: "Transmettre",
		},
		waiting_validation: {
			page_title: "En attente de validation",
			date: "Date d'envoi SDG",
		},
		validated: {
			page_title: "Validées",
			date: "Date de validation",
		},
		modal: {
			title: "Selectionnez une date",
			description: "Veuillez indiquer la date de validation de la souscription",
		},
	},
};

export default translations;
